import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { initialState } from '../initial';

export const resetAllAttendees = (create: ReducerCreators<AudiencesState>) =>
  create.reducer((state) => {
    state.allAttendees = initialState.allAttendees;
  });
